import { dynamicEditPagePanel } from '@wix/wix-data-client-common/dist/esm/bi/panelDataForBi'

export const { panelName } = dynamicEditPagePanel
